import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _class, _temp;

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Easings from 'easing-utils';

function doEase(pos, start, end) {
  return start + (end - start) * pos;
}

export var ease = function ease(easeName) {
  return function (t, start, end, duration) {
    return doEase(Easings[easeName](t / duration), start, end);
  };
};

var SequenceAnimator = (_temp = _class = function (_Component) {
  _inherits(SequenceAnimator, _Component);

  function SequenceAnimator() {
    _classCallCheck(this, SequenceAnimator);

    var _this = _possibleConstructorReturn(this, (SequenceAnimator.__proto__ || _Object$getPrototypeOf(SequenceAnimator)).call(this));

    _this._getFrame = function () {
      var frame = _this.state.frame;
      var children = _this.props.children;

      var childrenArr = React.Children.toArray(children);

      return childrenArr.length >= frame ? childrenArr[frame] : null;
    };

    _this._playAnimation = function () {
      _this._animationFrame = requestAnimationFrame(_this._onAnimate);
    };

    _this._onAnimate = function (timestamp) {
      var _this$props = _this.props,
          onSequenceEnd = _this$props.onSequenceEnd,
          onAnimationStop = _this$props.onAnimationStop,
          children = _this$props.children,
          loop = _this$props.loop,
          easing = _this$props.easing,
          duration = _this$props.duration;

      var childrenArr = React.Children.toArray(children);

      if (!_this._animationStart) {
        _this._animationStart = timestamp;
      }

      var nextFrame = Math.floor(ease(easing)(timestamp - _this._animationStart, 0, childrenArr.length, duration));

      if (nextFrame > childrenArr.length - 1) {
        onSequenceEnd();

        if (loop) {
          nextFrame %= childrenArr.length;
          _this._animationStart = timestamp;
        } else {
          nextFrame = -1;
        }
      }

      if (nextFrame > -1) {
        _this.setState({ frame: nextFrame }, function () {
          _this._playAnimation();
        });
      } else {
        onAnimationStop();
      }
    };

    _this.state = {
      frame: 0
    };
    return _this;
  }

  _createClass(SequenceAnimator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var autoplay = this.props.autoplay;


      if (autoplay) {
        this.start();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this._animationFrame);
    }
  }, {
    key: 'start',
    value: function start() {
      this._playAnimation();
    }
  }, {
    key: 'stop',
    value: function stop() {
      cancelAnimationFrame(this._animationFrame);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setState({ frame: 0 });
    }
  }, {
    key: 'render',
    value: function render() {
      var frame = this._getFrame();
      return React.createElement(
        'div',
        null,
        frame
      );
    }
  }]);

  return SequenceAnimator;
}(Component), _class.displayName = 'SequenceAnimator', _class.propTypes = {
  autoplay: PropTypes.bool,
  duration: PropTypes.number,
  loop: PropTypes.bool,
  easing: PropTypes.oneOf(_Object$keys(Easings)),
  onSequenceEnd: PropTypes.func,
  onAnimationStop: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}, _class.defaultProps = {
  duration: 1000,
  autoplay: true,
  easing: 'linear',
  loop: true,
  children: [],
  onSequenceEnd: function onSequenceEnd() {},
  onAnimationStop: function onAnimationStop() {}
}, _temp);
export { SequenceAnimator as default };